import React from 'react';
import {
  Button, Col, Form, Row,
} from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { NavLink } from 'react-router-dom';
import style from './style.module.less';

const RegisterFilterRow = ({buttonCreatorObject,children,separateButtons = false}) => {

    const buttonGroup = buttonCreatorObject?.filter(button => !button.hasOwnProperty('disabled') || !button?.disabled).map((button, index) => {
        if (((!button?.title || !button.url) && !button?.custom) || (button?.custom && !button?.title)) {
            throw new Error('In component RegisterFilterRow property buttonCreatorObject should have title and url.')
        }
        return button?.custom
            ?
            (<React.Fragment key={button.title}>
                {button.custom}
            </React.Fragment>)
            :
            <React.Fragment key={button.title}>
                <NavLink to={button?.url}>
                    <Button variant={button?.color ?? 'primary'}
                            className={`${style.button} ${button?.class}`}>{button.title}</Button>
                </NavLink>
            </React.Fragment>

    })

    return (
        <React.Fragment>
            <div className={`d-flex flex-row ${style.rowArticle} ${style.actionRowArticle}`}
                 style={{justifyContent: separateButtons ? 'space-between' : 'left', gap: !separateButtons && '16px'}}>
                {children}
                <div className={`${style.buttonGroups}`} style={{alignSelf: 'flex-end', justifyContent: 'center'}}>
                    {buttonGroup?.map(x => x)}
                </div>
            </div>
        </React.Fragment>
    )
}

export default RegisterFilterRow;
